var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular Rounded",
    clipPath: "url(#clip0_925_502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 0C16.5444 0 12.6776 1.17298 9.3886 3.37061C6.09962 5.56824 3.53617 8.69181 2.02242 12.3463C0.508666 16.0009 0.112599 20.0222 0.884303 23.9018C1.65601 27.7814 3.56082 31.3451 6.35787 34.1421C9.15492 36.9392 12.7186 38.844 16.5982 39.6157C20.4778 40.3874 24.4992 39.9913 28.1537 38.4776C31.8082 36.9638 34.9318 34.4004 37.1294 31.1114C39.327 27.8224 40.5 23.9556 40.5 20C40.4943 14.6974 38.3853 9.61368 34.6358 5.8642C30.8863 2.11471 25.8026 0.00573514 20.5 0V0ZM20.5 36.6667C17.2037 36.6667 13.9813 35.6892 11.2405 33.8578C8.49969 32.0265 6.36348 29.4235 5.10202 26.3781C3.84056 23.3326 3.5105 19.9815 4.15359 16.7485C4.79667 13.5155 6.38402 10.5458 8.7149 8.21489C11.0458 5.88401 14.0155 4.29667 17.2485 3.65358C20.4815 3.01049 23.8326 3.34055 26.8781 4.60201C29.9235 5.86347 32.5265 7.99968 34.3578 10.7405C36.1892 13.4813 37.1667 16.7036 37.1667 20C37.1618 24.4188 35.4043 28.6552 32.2798 31.7798C29.1552 34.9043 24.9188 36.6618 20.5 36.6667Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4998 16.6672H18.8332C18.3911 16.6672 17.9672 16.8428 17.6547 17.1554C17.3421 17.468 17.1665 17.8919 17.1665 18.3339C17.1665 18.7759 17.3421 19.1999 17.6547 19.5124C17.9672 19.825 18.3911 20.0006 18.8332 20.0006H20.4998V30.0006C20.4998 30.4426 20.6754 30.8665 20.988 31.1791C21.3005 31.4916 21.7245 31.6672 22.1665 31.6672C22.6085 31.6672 23.0324 31.4916 23.345 31.1791C23.6576 30.8665 23.8332 30.4426 23.8332 30.0006V20.0006C23.8332 19.1165 23.482 18.2687 22.8568 17.6435C22.2317 17.0184 21.3839 16.6672 20.4998 16.6672Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.5 13.3328C21.8807 13.3328 23 12.2135 23 10.8328C23 9.45205 21.8807 8.33276 20.5 8.33276C19.1193 8.33276 18 9.45205 18 10.8328C18 12.2135 19.1193 13.3328 20.5 13.3328Z",
    fill: "#EB001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-icon.6baf910df9bff7ba8309a9f32c3649f4.svg";
export { ForwardRef as ReactComponent };